import { useLocalization } from "@fluent/react";
import { Alert, LoadingSkeleton } from "@narmi/design_system";
import styles from "./OrganizationRoles.module.scss";

interface RoleDetailLoadingStatusProps {
  isLoading: boolean;
  isError: boolean;
}

/**
 * Stands in for the permission sections while the role detail loads, or when it failed, so a role
 * that is missing its permissions never reads as a complete description.
 */
export default function RoleDetailLoadingStatus({
  isLoading,
  isError,
}: RoleDetailLoadingStatusProps) {
  const { l10n } = useLocalization();

  if (isLoading) {
    return (
      <div className={styles.cardSection}>
        <LoadingSkeleton content="paragraph" lines={6} isLoading />
      </div>
    );
  }
  if (isError) {
    return (
      <div className={styles.cardSection}>
        <Alert kind="error" isActive isDismissable={false}>
          {l10n.getString("org-role-detail-error")}
        </Alert>
      </div>
    );
  }
  return null;
}
